import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hospital"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 9V3H18V9H21V21H3V9H6Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 21V15H14V21H10Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 8H12M12 8H14M12 8V6M12 8V10M10 15V21H14V15H10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 3C5.34388 3 5.67667 3 6 3M19 3C18.6561 3 18.3233 3 18 3M6 3V9C4.82099 9 4.52489 9 3 9V21H21V9C19.9327 9 18.9408 9 18 9V3M6 3C9.75964 3 14.2404 3 18 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Hospital = Vue.extend<IconProps>({
  name: 'HospitalIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'hospital',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Hospital;
